module.exports = __webpack_public_path__ + "static/media/viking_shield.7100e45a.png";